// import { v4 as uuid } from "uuid";

export const products = [
  // {
  //   _id: uuid(),
  //   title: "Assorted Tank top",
  //   description:
  //     "This is a stylish, trendy and modern tank top from the house of Clovia. It features a high degree of stretchability due to its fabric. Also, it is considered as an ideal choice for activewear. For those looking for a fine blend of comfort and style, this is a perfect choice. As it is a sleeveless tank top, it further adds to the glam quotient and makes one look all the more appealing.",
  //   original_price: "499",
  //   price: "159",
  //   rating: "4.1",
  //   size: ["S", "M", "L"],
  //   image:
  //     "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-assorted-tank-top-572829.jpg",
  //   category: "Topwear",
  //   brand: "ETC",
  //   fabric: "lycra",
  //   color: "red",
  //   new_arrivals: false,
  //   reviews: "4.5K",
  //   delivery_time: "2",
  // },
  {
    _id: "49fbdba9-47e3-4704-adf7-73ada955fb2d",
    title: "Tank Top",
    description:
      "Team this white-coloured tank top with a pair of comfy jeans and sneakers and your stylish look is complete. Made with cotton fabric, it is soft and comfortable to wear. Additionally, this sleeveless tank top has a round neckline and a racerback. This tank top features four-way stretchable fabric that is crease-free and doesn’t roll up. This fabric has a high degree of flexibility, which makes this top ideal for workouts. You can also use this tank top as a layering canvas over a shrug of your choice.",
    original_price: "499",
    price: "299",
    rating: "2.3",
    size: "M",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-cotton-racerback-tank-top-1-355314.jpg",
    category: "Topwear",
    brand: "Kanvin",
    fabric: "cotton",
    color: "white",
    new_arrivals: true,
    reviews: "200",
    delivery_time: "3",
  },
  {
    _id: "94aa649e-8c60-412a-88ce-04e1af7ef826",
    title: "Quirky Text Top",
    description:
      "Dark pink T-shirt crafted with 100% cotton fabric.Designed with quirky text print on the chest.Has a round neckline and short sleeves.",
    original_price: "999",
    price: "349",
    rating: "3.5",
    size: "M",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-quirky-text-top-in-dark-pink-100-cotton-677199.jpg",
    category: "Topwear",
    brand: "FashionRack",
    fabric: "cotton",
    color: "pink",
    new_arrivals: false,
    reviews: "172",
    delivery_time: "2",
  },
  {
    _id: "8e0218ab-5bb8-4597-86cc-714fbcd15daf",
    title: "Music Magic Top",
    description:
      "Dark pink T-shirt crafted with 100% cotton fabric. Designed with cool headphone and text print at the chest. Has a round neckline and short sleeves.",
    original_price: "999",
    price: "329",
    rating: "4.1",
    size: "L",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-lt0124f14-726353.JPG",
    category: "Topwear",
    brand: "Kryptic",
    fabric: "cotton",
    color: "pink",
    new_arrivals: true,
    reviews: "297",
    delivery_time: "2",
  },
  {
    _id: "4547f17a-2caf-44c4-bca7-4a4361ca6db3",
    title: "Chic Basic Top",
    description:
      "Black top crafted with soft cotton rich fabric. Designed with round neck & short sleeves.",
    original_price: "899",
    price: "329",
    rating: "2.7",
    size: "XL",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-chic-basic-top-in-black-cotton-rich-1-898972.jpg",
    category: "Topwear",
    brand: "Dreamz",
    fabric: "cotton",
    color: "black",
    new_arrivals: false,
    reviews: "3.7K",
    delivery_time: "3",
  },
  {
    _id: "c19b1521-6763-4145-ba44-6049210c786c",
    title: "But First Coffee Top",
    description:
      "Light grey printed top crafted with premium cotton fabric. Designed wtih round neckline and short sleeves.",
    original_price: "999",
    price: "399",
    rating: "4.5",
    size: "L",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-printed-top-in-light-grey-100-cotton-937622.jpg",
    category: "Topwear",
    brand: "evolove",
    fabric: "cotton",
    color: "blue",
    new_arrivals: true,
    reviews: "79",
    delivery_time: "3",
  },
  {
    _id: "e5052a2d-c475-4e93-9278-df8cbc27ad3b",
    title: "Chic Basic Pyjama",
    description:
      "Blue pyjama crafted with soft crepe fabric. Elasticated waistband & pockets on both sides.",
    original_price: "1299",
    price: "399",
    rating: "1.7",
    size: "XL",
    in_stock: false,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-lb0186p08-829429.JPG",
    category: "Bottomwear",
    brand: "Berrylush",
    fabric: "crepe",
    color: "blue",
    new_arrivals: false,
    reviews: "187",
    delivery_time: "3",
  },
  {
    _id: "b66ff66d-a808-4707-8a49-0faba0ce2ce6",
    title: "Pretty Florals Pyjama",
    description:
      "Multicolour pyjama crafted with soft velour fabric. Designed with floral print all over. Has an elasticated waistband for snug fit. Pockets on both sides.",
    original_price: "2749",
    price: "749",
    rating: "3.5",
    size: "XXL",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-lb0139a19-479514.jpg",
    category: "Bottomwear",
    brand: "ETC",
    fabric: "cotton",
    color: "multi",
    new_arrivals: false,
    reviews: "978",
    delivery_time: "3",
  },
  {
    _id: "76d5a05e-50ad-46ab-b8e8-44f791989a12",
    title: "Chic Basic Cuffed Joggers",
    description:
      "Light grey joggers crafted with super-soft loop knit fleece fabric. Has an elasticated waistband with a fastening drawstring. Cuffed leg openings for comfort fit. Has pockets on both sides.",
    original_price: "1899",
    price: "569",
    rating: "3.2",
    size: "M",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-chic-basic-cuffed-joggers-in-light-grey-loop-knit-683076.jpg",
    category: "Bottomwear",
    brand: "Berrylush",
    fabric: "knitted",
    color: "grey",
    new_arrivals: true,
    reviews: "87",
    delivery_time: "3",
  },
  {
    _id: "1cd4ecde-5254-4d9b-a697-30ad305b93f4",
    title: "Chic Basic Wide Leg Pants",
    description:
      "Maroon wide leg pants crafted with soft rayon fabric. Has a button closure & loops at the waist. Pockets on both sides.",
    original_price: "1999",
    price: "592",
    rating: "2.1",
    size: "XL",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-lb0192p09-476683.jpg",
    category: "Bottomwear",
    brand: "evolove",
    fabric: "rayon",
    color: "maroon",
    new_arrivals: true,
    reviews: "3.6K",
    delivery_time: "3",
  },
  {
    _id: "7545e7be-112a-4c4a-910f-699222c6adf9",
    title: "Print Me Pretty Boxer Shorts",
    description:
      "White boxer shorts crafted with soft 100% cotton fabric. Designed with heart print all over. Has an elasticated waist for a snug fit. Has pockets on each side.",
    original_price: "1099",
    price: "399",
    rating: "3.5",
    size: "XXL",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-lb0174k18-452064.jpg",
    category: "Bottomwear",
    brand: "Dreamz",
    fabric: "cotton",
    color: "white",
    new_arrivals: true,
    reviews: "3K",
    delivery_time: "3",
  },
  {
    _id: "21d2a99e-eda8-494c-9be0-a13d095cd7a3",
    title: "Sassy Stripes Boxer Shorts",
    description:
      "White & black striped boxer shorts crafted with soft & premium 100% cotton fabric. Has an elasticated waist for a snug fit. Pockets on each side.",
    original_price: "999",
    price: "399",
    rating: "3.8",
    size: "XL",
    in_stock: false,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-lb0174y18-911802.jpg",
    category: "Bottomwear",
    brand: "Kryptic",
    fabric: "cotton",
    color: "white",
    new_arrivals: false,
    reviews: "156",
    delivery_time: "3",
  },
  {
    _id: "30f62f25-55b1-444a-9399-fabac8501bb0",
    title: "Print Me Pretty Pyjama",
    description:
      "Red pyjama crafted with soft rayon fabric. Designed with triangle print all over. Elasticated waistband for a snug fit. Pockets on both sides.",
    original_price: "2049",
    price: "772",
    rating: "3.5",
    size: "M",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-lb0179e04-309727.jpg",
    category: "Bottomwear",
    brand: "FashionRack",
    fabric: "rayon",
    color: "red",
    new_arrivals: true,
    reviews: "546",
    delivery_time: "3",
  },
  {
    _id: "a4bca814-043a-40b7-ac20-1cc27195dbef",
    title: "Print Me Pretty Kaftan Top & Pyjama",
    description:
      "Sky blue printed kaftan top & pyjama set crafted with soft & premium 100% cotton fabric. Kaftan top has a V-neckine & short sleeves. Has an elasticated underbust with tie-up detail. Matching pyjama has an elasticated waistband for snug fit. Pockets on both side.",
    original_price: "2599",
    price: "1698",
    rating: "1.9",
    size: "M",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-ls0592r03-589836.jpg",
    category: "Loungewear",
    brand: "Kanvin",
    fabric: "cotton",
    color: "blue",
    new_arrivals: true,
    reviews: "77",
    delivery_time: "3",
  },
  {
    _id: "864430f0-55b5-4c4d-8a15-1bad153b0d52",
    title: "Chic Basic Button Down Shirt & Pyjama Set",
    description:
      "Soft pink button down shirt & pyjama set crafted with soft cotton modal fabric. Shirt with full button placket & short sleeves. Has frilled edges at the sleeves & hemline. Matching pyjama with elasticated waistband & drawstring fastening for a snug fit. Pockets on both sides.",
    original_price: "2499",
    price: "1999",
    rating: "4.1",
    size: "L",
    in_stock: false,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-chic-basic-button-me-up-shirt-pyjama-set-in-soft-pink-modal-759952.jpg",
    category: "Loungewear",
    brand: "ETC",
    fabric: "modal",
    color: "pink",
    new_arrivals: false,
    reviews: "59",
    delivery_time: "3",
  },
  {
    _id: "ace24314-bfa6-498c-abd5-d30c709deccb",
    title: "Chic Basic Top & Pyjama Set",
    description:
      "Baby pink top and pyjama set crafted with soft & cosy velour fabric. Top has a round neck & full sleeves with elasticated cuffs. Matching pyjama with soft elastic at the waistband. Pockets on both sides.",
    original_price: "3499",
    price: "2799",
    rating: "2.5",
    size: "3XL",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-chic-basic-top-pyjama-set-in-baby-pink-velour-326603.jpg",
    category: "Loungewear",
    brand: "Kanvin",
    fabric: "velour",
    color: "pink",
    new_arrivals: false,
    reviews: "59",
    delivery_time: "4",
  },
  {
    _id: "30f5597c-db4c-4491-8b43-cf5324ab8cc0",
    title: "Chic Basic Top, Pyjama & Shrug Set",
    description:
      "Black top, pyjama & shrug set crafted with soft & cosy velour fabric. Cami top with a round neck. Comes with a matching shrug that has full sleeves. Pyjama with an elasticated waistband for a snug fit. Has pockets on both sides.",
    original_price: "3299",
    price: "2799",
    rating: "3.9",
    size: "M",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-chic-basic-top-pyjama-shrug-set-in-black-velour-572703.jpg",
    category: "Loungewear",
    brand: "FashionRack",
    fabric: "velour",
    color: "black",
    new_arrivals: true,
    reviews: "5K",
    delivery_time: "3",
  },
  {
    _id: "dbb61999-8b90-4ed4-8167-d42aaa959198",
    title: "Chic Basic Button Down Shirt & Pyjama Set",
    description:
      "Dusky pink button-down shirt & pyjama set crafted with smooth rayon fabric. Has a full button placket & 3/4 sleeves. Matching pyjama with elasticated waistband for snug fit. Pockets on both sides.",
    original_price: "999",
    price: "789",
    rating: "1.9",
    size: "XL",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-chic-basic-button-me-up-shirt-pyjama-set-in-dusky-pink-satin-426522.jpg",
    category: "Loungewear",
    brand: "Kryptic",
    fabric: "rayon",
    color: "pink",
    new_arrivals: false,
    reviews: "270",
    delivery_time: "3",
  },
  {
    _id: "f7e9de6f-c5ba-44fc-86aa-ab28e041f5c8",
    title: "Sassy Stripes 3 Piece Set- Top, Pyjama & Robe",
    description:
      "Top, pyjama, and robe set crafted with rayon fabric. Maroon striped top designed with a round neck and 3/4 sleeves. Matching pyjama with an elasticated waistband for a snug fit. Pockets on both sides. Comes with a stylish robe with 3/4 sleeves and tie-ups.",
    original_price: "2499",
    price: "1007",
    rating: "3.5",
    size: "L",
    in_stock: false,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-sassy-stripes-top-pyjama-robe-set-in-maroon-rayon-513226.jpg",
    category: "Loungewear",
    brand: "Dreamz",
    fabric: "rayon",
    color: "maroon",
    new_arrivals: false,
    reviews: "3.8K",
    delivery_time: "3",
  },
  {
    _id: "035d9622-cd63-4dc6-8225-9648aa66e231",
    title: "Cotton Rich Pyjama",
    description:
      "Made using the soft and breathable rich-cotton fabric for maximum ease and comfort all day long, this stylish pyjama comes with soft and flexible elastic band at the waistline to avoid slide down and provide a better and comfortable fit. Its fabric gives a smooth feel on the skin. The pyjama is coloured in black. Also, it has pockets on both sides.",
    original_price: "899",
    price: "349",
    rating: "1.5",
    size: "M",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-cotton-rich-pyjama-1-729815.jpg",
    category: "Loungewear",
    brand: "evolove",
    fabric: "cotton",
    color: "black",
    new_arrivals: true,
    reviews: "2K",
    delivery_time: "3",
  },
  {
    _id: "6aa6fb71-0a35-4924-bcec-f3940fff109e",
    title: "Fish Print Top & Pyjama",
    description:
      "Top & pyjama set crafted with soft & premium 100% cotton fabric. Sky blue top designed with fish print at the chest. Has a round neckline with 3/4th sleeves. Maroon pyjama designed with fish print all over. Has an elasticated waistband for snug fit. Pockets on both sides.",
    original_price: "3749",
    price: "855",
    rating: "2.1",
    size: "M",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-ls0680a08-624984.jpg",
    category: "Nightsuit",
    brand: "Berrylush",
    fabric: "cotton",
    color: "blue",
    new_arrivals: true,
    reviews: "200",
    delivery_time: "3",
  },
  {
    _id: "6596a60c-2468-4555-a9f7-64d5572d88f6",
    title: "Animal Print Top & Capri Set",
    description:
      "Olive green top & capri set crafted with soft rayon fabric. Designed with animal print all over. Top has a round neck & short sleeves with frilled edges. Matching pyjama with frilled hems. Has an elasticated waistband for snug fit. Pockets on both sides.",
    original_price: "3249",
    price: "735",
    rating: "3.1",
    size: "M",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-ls0696p17-542461.jpg",
    category: "Nightsuit",
    brand: "evolove",
    fabric: "rayon",
    color: "green",
    new_arrivals: false,
    reviews: "178",
    delivery_time: "3",
  },
  {
    _id: "d8a5241e-263f-46d1-8183-38b2521d798b",
    title: "Print Me Pretty Button Down Shirt & Pyjama Set",
    description:
      "Lilac button down shirt & pyjama set crafted with premium 100% cotton fabric. Designed with bee & rainbow print all over. Shirt has 3/4th sleeves & a full button placket. Matching pyjama with soft elastic at the waistband & drawstring fastening for a snug fit. Pockets on both sides.",
    original_price: "4099",
    price: "932",
    rating: "3.1",
    size: "3XL",
    in_stock: false,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-print-me-pretty-button-down-shirt-pyjama-set-in-lilac-100-cotton-188179.jpg",
    category: "Nightsuit",
    brand: "Dreamz",
    fabric: "cotton",
    color: "pink",
    new_arrivals: false,
    reviews: "2.5K",
    delivery_time: "3",
  },
  {
    _id: "9ab6d932-9535-4365-a0ad-d81fa7dabf0f",
    title: "Graphic & Text Print Top & Chic Basic Joggers",
    description:
      "Top & pyjama set crafted with soft & premium 100% cotton fabric. Yellow top designed with graphic & text print at the front. Has a round neckline with contrast piping & 3/4th sleeves. Purple joggers with elasticated waistband & drawstring fastening for a snug fit. Pockets on both sides.",
    original_price: "3699",
    price: "836",
    rating: "2.1",
    size: "L",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-ls0581p07-279215.jpg",
    category: "Nightsuit",
    brand: "Kryptic",
    fabric: "cotton",
    color: "yellow",
    new_arrivals: false,
    reviews: "2.5K",
    delivery_time: "3",
  },
  {
    _id: "64c19dd5-fb13-48e5-b510-fd454a62ff00",
    title: "Print Me Pretty Top & Chic Basic Shorts",
    description:
      "Top & shorts set crafted with soft & premium 100% cotton fabric. Baby blue top designed with duck & text print at the front. Has a round neckline & 3/4th sleeves. Baby pink shorts with elasticated waistband & drawstring fastening for a snug fit. Pockets on both sides.",
    original_price: "2949",
    price: "668",
    rating: "1.9",
    size: "XL",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-print-me-pretty-top-in-baby-blue-chic-basic-shorts-in-baby-pink-100-cotton-909764.jpg",
    category: "Nightsuit",
    brand: "FashionRack",
    fabric: "cotton",
    color: "blue",
    new_arrivals: false,
    reviews: "2.5K",
    delivery_time: "3",
  },
  {
    _id: "0acb7d32-99e4-489f-88bd-e8bec7d3e043",
    title: "Butterfly Print Top & Shorts Set",
    description:
      "Yellow top & shorts set crafted with soft & premium 100% cotton fabric. Top has round neck & short sleeves with lettuce hem edges. Designed with butterfly print on one side. Matching shorts with elasticated waistband for a snug fit. Designed with butterfly print all over & has lettuce hemline. Pockets on both sides.",
    original_price: "2499",
    price: "549",
    rating: "4.5",
    size: "XL",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-ls0555a02-397620.jpg",
    category: "Nightsuit",
    brand: "Kanvin",
    fabric: "cotton",
    color: "yellow",
    new_arrivals: false,
    reviews: "2.5K",
    delivery_time: "3",
  },
  {
    _id: "23bf9fce-2631-4577-a753-00d744ffaff4",
    title: "Dot Print Button Down Shirt & Pyjama Set",
    description:
      "Baby pink button down shirt & pyjama set crafted with soft & premium 100% fabric. Designed with multicolour dot print all over. Has a full button placket & short sleeves. Matching pyjama with elasticated waistband for a snug fit. Pockets on both sides.",
    original_price: "4099",
    price: "932",
    rating: "3.5",
    size: "3XL",
    in_stock: false,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-ls0645d22-106857.jpg",
    category: "Nightsuit",
    brand: "ETC",
    fabric: "cotton",
    color: "pink",
    new_arrivals: false,
    reviews: "200",
    delivery_time: "2",
  },
  {
    _id: "a4a78b34-cab0-4d4b-9a06-a952c18da59b",
    title: "Heart Print Cami Top & Shorts Set",
    description:
      "White cami top & shorts set crafted with premium 100% cotton fabric. Designed with heart print all over. Top has round neckline. Has scalloped lace along the neckline & under the armholes. Has adjustable black spaghetti straps. Matching shorts has an elasticated waistband for snug fit. Has scalloped lace on the hemline. Pockets on both sides.",
    original_price: "2499",
    price: "489",
    rating: "3.9",
    size: "M",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-ls0516g18-168815.jpg",
    category: "Nightsuit",
    brand: "Kanvin",
    fabric: "cotton",
    color: "white",
    new_arrivals: true,
    reviews: "2.5K",
    delivery_time: "3",
  },
  {
    _id: "4e7a678c-22be-4f8c-b741-474abfdb7820",
    title: "Pretty Florals Long Nighty",
    description:
      "Maroon long nightdress crafted with soft cotton rich fabric. Designed with white & green floral print. Has a round neck with a short button placket. Designed with 3/4 sleeves and a ruffled bottom.",
    original_price: "2099",
    price: "811",
    rating: "3.1",
    size: "M",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-ns1359p09-444585.jpg",
    category: "Nightdress",
    brand: "FashionRack",
    fabric: "cotton",
    color: "maroon",
    new_arrivals: true,
    reviews: "2.5K",
    delivery_time: "3",
  },
  {
    _id: "caf0075a-10a5-4e39-8775-c71f0e8168db",
    title: "Leaf Print Long Kaftan",
    description:
      "Black kaftan crafted with smooth crepe fabric. Designed with red leaf print all over. Has an elasticated underbust with tie-ups for a comfy snug fit. Has a V-neckline & short sleeves.",
    original_price: "1899",
    price: "851",
    rating: "3.1",
    size: "XL",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-ns0865e13-868120.jpg",
    category: "Nightdress",
    brand: "Kryptic",
    fabric: "crepe",
    color: "black",
    new_arrivals: true,
    reviews: "271",
    delivery_time: "3",
  },
  {
    _id: "1632cee9-f7ee-4018-a7a6-0d180ba3baa0",
    title: "Pretty Florals Short Night Dress",
    description:
      "Grey short night dress crafted with soft & premium 100% cotton fabric. Has a round neck and short sleeves with ruffled hems. Designed with white & peach floral print all over. Has pockets on both sides.",
    original_price: "999",
    price: "799",
    rating: "1.5",
    size: "XL",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-pretty-florals-short-nightdress-in-grey-100-cotton-947912.jpg",
    category: "Nightdress",
    brand: "Dreamz",
    fabric: "cotton",
    color: "grey",
    new_arrivals: false,
    reviews: "21",
    delivery_time: "3",
  },
  {
    _id: "9fa1f471-6c82-4fbd-bd58-4f4d50edb40c",
    title: "Tie-Dye Print Short Night Dress",
    description:
      "Multicolour short nightdress crafted with soft & premium 100% cotton fabric. Designed with blue, pink & yellow tie-dye print all over. Has deep U-neckine, adjustable shoulder straps & tie-up waistbelt. Pockets on both sides.",
    original_price: "1199",
    price: "999",
    rating: "3.1",
    size: "S",
    in_stock: false,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-tie-dye-print-short-night-dress-in-multicolour-100-cotton-274925.jpg",
    category: "Nightdress",
    brand: "evolove",
    fabric: "cotton",
    color: "multi",
    new_arrivals: false,
    reviews: "841",
    delivery_time: "3",
  },
  {
    _id: "900a4f22-65fe-42dc-ae9b-953205e3110b",
    title: "Giraffe Print Short Night Dress",
    description:
      "Sky blue short night dress crafted with soft & premium 100% cotton fabric. Designed with giraffe print all over. Has a round neckline, short button placket & a chest pocket. Racerback for added appeal. Pocket on both sides.",
    original_price: "1899",
    price: "489",
    rating: "3.1",
    size: "XL",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-giraffe-print-short-night-dress-in-sky-blue-100-cotton-893875.jpg",
    category: "Nightdress",
    brand: "Berrylush",
    fabric: "cotton",
    color: "blue",
    new_arrivals: false,
    reviews: "631",
    delivery_time: "3",
  },
  {
    _id: "880ab335-36bc-4e47-94ad-2ae3da9a2ebe",
    title: "Chic Basic Short Nighty & Cactus Print Robe Set",
    description:
      "White robe & baby pink short nighty set crafted with luxurious satin fabric. Short nighty has V-neckline & armhole embellished with lace. Has spaghetti straps & ruching under the bust. The robe has a pink tie-up belt at the waistline & 3/4th sleeves. Designed with green cactus print.",
    original_price: "1699",
    price: "875",
    rating: "3.1",
    size: "M",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-ns1145r18-905361.jpg",
    category: "Nightdress",
    brand: "evolove",
    fabric: "satin",
    color: "white",
    new_arrivals: true,
    reviews: "21",
    delivery_time: "3",
  },
  {
    _id: "b141ad3c-9a4c-4144-9687-ed73fe3cd875",
    title: "Pretty Florals Robe",
    description:
      "Rust brown robe crafted with luxurious satin fabric. Has 3/4th floral print sleeves & upper half back. Comes with a matching floral print fabric belt.",
    original_price: "1199",
    price: "899",
    rating: "4.8",
    size: "M",
    in_stock: true,
    image:
      "https://image.clovia.com/media/clovia-images/images/400x600/clovia-picture-chic-basic-robe-short-nighty-set-in-rust-brown-satin-896300.jpg",
    category: "Nightdress",
    brand: "Dreamz",
    fabric: "satin",
    color: "brown",
    new_arrivals: true,
    reviews: "3.9K",
    delivery_time: "3",
  },
];
